<template>
  <div>
    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :value="value" 
        :loading="loading"
        :options="labs" 
        :close-on-select="true"
        :reduce="val => val.id" 
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="name" 
        clearable 
        @search="fetchLabs"
        @input="onOptionSelected"
      >
        <template #list-header>
          <li class="d-flex align-content-between align-items-center" style="opacity: 0.8; text-align: center; padding: 5px;">
            <div class="flex-grow-1">Start typing to fetch labs</div>
          </li>
        </template>

        <template #no-options>
          No options available
        </template>
      </v-select>
    </div>
  </div>
</template>
  
<script>
import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  
export default {
  components: {
    vSelect,
    BButton,

  },
  props: {
    value: {
      default: "",
      type: String,
      required: false,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,

      labs: [],
      storeName: "labFrequencyStore",
    }
  },
  created() {
    if (this.value){
      this.fetchLabs(this.value, () => {});
    } else {
      this.labs = this.getFrequencyStore(this.storeName)
    }
  },
  methods: {
    async fetchLabs(text, loadingMutator) {
      try {
        this.loading = true; 
        loadingMutator(true);

        const query = {
          page: 1,
          limit: 50,
          search: text || this.value,
          status: 'approved'
        }
        
        const request = await this.useJwt().mainService.labs.list(query);
        const { data } = request.data;
        this.labs = data.map(opt => ({ id: opt._id, name: opt.facility_details.lab_name }))
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
        loadingMutator(false);
      }
    },
    onOptionSelected(lab_id){
      this.$emit('change', lab_id)

      const selectedOption = this.labs.find(record => record.id === lab_id);
      if (selectedOption) {
        this.updateFrequencyStore(this.storeName, selectedOption);
      }
    },
  }
}
</script>
